import { mainSiteUrl } from "@/mocks/categories";

export default function FeatureCards() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="text-xs text-foreground-400 uppercase tracking-[0.3em] font-medium">AC / BUY</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mt-3 leading-tight">
            Your Gateway to Smart Purchasing
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="group bg-foreground-900 rounded-3xl p-6 md:p-8 flex flex-col justify-between min-h-[320px] cursor-pointer transition-all duration-300 hover:-translate-y-1"
          >
            <div>
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-foreground-700 text-white text-sm font-bold">
                01
              </span>
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-white leading-tight">
                Main Store Portal
              </h3>
              <p className="text-sm text-foreground-300 mt-3">
                Access the complete product catalog with ACBuySpreadsheet tracking system.
              </p>
            </div>
          </a>

          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-3xl overflow-hidden min-h-[320px] cursor-pointer transition-all duration-300 hover:-translate-y-1"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Trending%20fashion%20items%20flatlay%20featuring%20sneakers%20cap%20and%20accessories%20on%20warm%20cream%20surface%20with%20soft%20golden%20hour%20sunlight%2C%20lifestyle%20product%20photography%2C%20cozy%20autumn%20vibes%2C%20warm%20amber%20and%20beige%20tones%2C%20scandinavian%20editorial%20style%2C%20gentle%20long%20shadows%2C%20organic%20textures%2C%20aspirational%20shopping%20mood&width=800&height=600&seq=feature-hot-v2&orientation=portrait"
              alt="Top deals on ACBuySpreadsheet"
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
            <div className="absolute top-4 left-4">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-black/40 backdrop-blur-sm rounded-full text-xs text-white font-medium">
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-500"></i>
                </span>
                Hot Picks
              </span>
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-white leading-tight">
                Top Deals Today
              </h3>
            </div>
          </a>

          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="group bg-background-100 rounded-3xl p-6 md:p-8 flex flex-col justify-between min-h-[320px] cursor-pointer transition-all duration-300 hover:-translate-y-1"
          >
            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 leading-tight">
                Spreadsheet Tools
              </h3>
              <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
                Powerful order tracking and management tools powered by ACBuySpreadsheet technology.
              </p>
            </div>
            <div className="mt-4 rounded-2xl overflow-hidden aspect-[16/9] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20workspace%20with%20laptop%20screen%20showing%20organized%20spreadsheet%20dashboard%20with%20colorful%20data%20rows%20and%20charts%2C%20warm%20cream%20office%20interior%2C%20soft%20natural%20daylight%20from%20window%2C%20scandinavian%20home%20office%20aesthetic%2C%20clean%20organized%20desk%20with%20succulents%20and%20ceramic%20mug%2C%20calm%20productive%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=feature-tools-v2&orientation=landscape"
                alt="ACBuySpreadsheet tools"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                loading="lazy"
              />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}